function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFBF00",
  d: "M35.706 6.844L5.894 19.18c-1.658.686-1.64 3.04.027 3.702l29.937 11.872a11.108 11.108 0 0 0 8.19 0l29.937-11.872c1.668-.661 1.686-3.016.027-3.702L44.201 6.844a11.109 11.109 0 0 0-8.495 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#26B5F8",
  d: "M42.61 41.237v29.656a1.997 1.997 0 0 0 2.733 1.857L78.7 59.802a1.997 1.997 0 0 0 1.261-1.857V28.288a1.997 1.997 0 0 0-2.733-1.856L43.87 39.38a1.997 1.997 0 0 0-1.26 1.857"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ED3049",
  d: "M34.82 42.767l-9.9 4.78-1.006.486L3.016 58.046C1.69 58.686 0 57.72 0 56.248V28.413c0-.533.273-.992.64-1.338a2.27 2.27 0 0 1 .505-.38c.5-.3 1.212-.38 1.817-.14l31.691 12.557c1.611.639 1.738 2.896.167 3.655"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.25,
  d: "M34.82 42.767l-9.9 4.78L.64 27.075a2.27 2.27 0 0 1 .505-.38c.5-.3 1.212-.38 1.817-.14l31.691 12.557c1.611.639 1.738 2.896.167 3.655"
}));

var SvgAirtableIco = function SvgAirtableIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAirtableIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/airtable_ico.28705b27.svg";
export { ForwardRef as ReactComponent };